import { useMemo } from 'react';
import { useHasGate, useScopes } from '../accounts';

const useHasPartnerGate = () => {
  return useHasGate('AcademyCertification:ForcePartnerCertification');
};

const useHasPartnerScopes = () => {
  const scopes = useScopes();
  const hasPartnerScope = useMemo(() => scopes && (scopes.includes('partner-certifications') || scopes.includes('academy-partner-training-access') && scopes.includes('partner-paywall-hide')), [scopes]);
  if (!scopes) return null;
  return hasPartnerScope;
};

export const useIsPartner = () => {
  const hasGate = useHasPartnerGate();
  const hasScope = useHasPartnerScopes();
  return hasGate || hasScope;
};